import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import McActions from 'store/redux/mc'
import { pageData } from 'decorators'
import { translate } from 'react-i18next'
import filter from 'lodash/filter'
import moment from 'moment'
import { McNavBar, RTableSticky } from 'components'
import { McGameListFilters } from './Filters/McGameListFilters'

import './McGameList.css'


@connect(
    state => ({
        list: state.mc.gameList || [],
    }),
    {
        requestGameCSV: McActions.requestGameCSV,
    }
)
@translate()
@pageData({ title: 'Game List' })
export class McGameList extends Component {
    constructor(props) {
        super(props)
        const { list, requestGameCSV, t } = props
        this.columns = tableColumns(requestGameCSV)(t)
        this.transformedList = listTransform(list)
        this.state = {
            filteredItems: this.transformedList
        }
    }
    handleFiltersChange = filters => {
        this.setState({ filteredItems: filterList(this.transformedList, filters) })
    }

    render() {
        const { list, t } = this.props
        const { filteredItems } = this.state
        return (
            <div className="McGameList flex col-stretch">
                <McNavBar title={'MC VISUAL'} backRoute="/mc" withSignout />
                <section className="McGameList-Content flex-grow flex col-stretch">
                    {list.length > 0 ? (
                        <Fragment>
                            <McGameListFilters onChange={this.handleFiltersChange} />
                            {filteredItems.length > 0 ? (
                                <div className="flex-grow position-relative w-100">
                                    <div className="position-absolute-fill">
                                        <RTableSticky columns={this.columns} items={filteredItems} innerBordered className="h-100" />
                                    </div>
                                </div>
                            ) : (
                                    <div className="text-center">{t('mc.gameList.emptyFilteredList')}</div>
                                )}
                        </Fragment>
                    ) : (
                            <div className="text-center">{t('mc.gameList.emptyList')}</div>
                        )}
                </section>
            </div>
        )
    }
}


const listTransform = list => list.map(game => ({
    ...game,
    key: game.code,
    createdAt: game.createdAt ? moment(game.createdAt) : null,
    rowProps: {
        bgColor: game.completed ? 'green' : undefined
    }
}))

const filterList = (list, { startDate, endDate, code, onlyCompleted }) => filter(list, game => {
    if (startDate && game.createdAt && game.createdAt.isSameOrBefore(startDate)) return false
    if (endDate && game.createdAt && game.createdAt.isSameOrAfter(endDate)) return false
    if (code && code.length > 0 && game.code.toLowerCase().indexOf(code.toLowerCase()) === -1) return false
    if (onlyCompleted && !game.completed) return false
    return true
})

const tableColumns = downloadAction => t => [
    {
        key: 'code',
        type: 'text',
        value: t('mc.gameList.tableHeaders.code'),
        align: 'left',
        cellProps: {
            align: 'left',
        }
    },
    {
        key: 'numPlayers',
        type: 'text',
        value: t('mc.gameList.tableHeaders.players'),
        align: 'center',
        cellProps: {
            align: 'center',
        }
    },
    {
        key: 'numBots',
        type: 'text',
        value: t('mc.gameList.tableHeaders.bots'),
        align: 'center',
        cellProps: {
            align: 'center',
        }
    },
    {
        key: 'numSeasons',
        type: 'text',
        value: t('mc.gameList.tableHeaders.seasons'),
        align: 'center',
        cellProps: {
            align: 'center',
        }
    },
    {
        key: 'numRaces',
        type: 'text',
        value: t('mc.gameList.tableHeaders.races'),
        align: 'center',
        cellProps: {
            align: 'center',
        }
    },
    {
        key: 'status',
        type: 'text',
        value: t('mc.gameList.tableHeaders.status'),
        align: 'center',
        cellProps: {
            align: 'center',
            weight: 'bold',
            value: game => t(game.completed ? 'mc.gameList.status.completed' : 'mc.gameList.status.incompleted'),
        }
    },
    {
        key: 'download',
        type: 'text',
        cellProps: {
            align: 'right',
            type: 'button',
            value: game => ({
                text: t('mc.gameList.downloadBtn'),
                action: () => downloadAction(game.code),
            })
        }
    }
]



// WEBPACK FOOTER //
// src/pages/MC/GameList/McGameList.js